/**
 * USASpending Data Context
 *
 * Provides fetch functions for USASpending API data.
 * All functions require an access token as the first parameter.
 */

// Fetch functions
export {
  fetchAward,
  fetchAwardTransactions,
  fetchAwardSubawards,
  fetchAwardOrders,
  fetchIdvChildAggregation,
  fetchIdvActivity,
  fetchSubaward,
  fetchRecipient,
  fetchRecipientBasicInfo,
  fetchRecipientProfile,
  fetchRecipientStats,
  fetchRecipientAnalyticsAgencies,
  fetchRecipientAnalyticsPsc,
  fetchRecipientAnalyticsNaics,
  fetchRecipientRecentAwards,
  fetchRecipientDashboard,
  fetchRecipientInsights,
  fetchRecipientOfficers,
  fetchRecipientHierarchy,
  fetchAgency,
  fetchAgencyProfile,
  fetchAgencyBasicInfo,
  fetchAgencyAnalyticsRecipients,
  fetchAgencyAnalyticsNaics,
  fetchAgencyOpportunities,
  fetchPerson,
  // Analytics fetch functions
  fetchRecipientTimeSeries,
  fetchRecipientAwardPortfolio,
  fetchRecipientOutlayTimeSeries,
  fetchAwardTimeSeries,
  fetchIdvParent,
  fetchRecipientAwardTypes,
  fetchRecipientGeography,
  fetchRecipientGeographyCities,
  fetchRecipientSetAsides,
  fetchRecipientCompetition,
  fetchRecipientContractSizes,
  fetchRecipientCeilingTimeSeries,
  fetchIdvGroupTimeSeries,
  fetchAgencyTimeSeries,
  fetchAgencyAwardTypes,
  fetchAgencyGeography,
  fetchAgencySetAsides,
  fetchAgencyTopPscCodes,
  // Public (unauthenticated) fetchers for ISR
  fetchRecipientBasicInfoPublic,
  fetchRecipientDashboardPublic,
  // Types
  type ApiAwardListItem,
  type ApiOrderItem,
  type ApiIdvChildAggregation,
  type ApiIdvActivityResponse,
  type ApiIdvActivityNode,
  type ApiIdvActivityLink,
  type ApiIdvActivitySummary,
  type ApiRecipientListItem,
  type RecipientHierarchy,
  type RecipientHierarchyNode,
  type ApiAgencyListItem,
} from './liveFetcher'
